<div class="customer-agreement">
    <div class="contacts">

        <h2>
            Пользовательское соглашение
        </h2>

        <div class="info" [innerHTML]="customerAgreement"></div>

    </div>
</div>
